/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespComponents_user = {
    readonly " $fragmentRefs": FragmentRefs<"TradePromo_user" | "SbRespNullSearchResults_user" | "SbRespFollowSearchBanner_user" | "SbRespFollowTopButton_user" | "SbSharedFollowSearchProvider_user" | "SharedRecentlyViewedItems_user" | "SbRespMainContent_user" | "SbRespInteriorsWordpressArticlesWrapper_user">;
    readonly " $refType": "SbRespComponents_user";
};
export type SbRespComponents_user$data = SbRespComponents_user;
export type SbRespComponents_user$key = {
    readonly " $data"?: SbRespComponents_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespComponents_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespComponents_user",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TradePromo_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespFollowTopButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespInteriorsWordpressArticlesWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'd7da25fe6c42f0aae4e36dd4ecaaa7d7';
export default node;
